import {db} from './firebase.js';
import {useEffect, useState} from 'react';
import firebase from 'firebase';
import { $, jQuery} from 'jquery';


function Post(props){
    const [user, setUser] = useState();
    const [comentarios,setComentarios] = useState([]);
    const [likes,setLikes] = useState([])

    useEffect(() => {

        db.collection('posts').doc(props.id).collection('comentarios').orderBy('timestamp','desc').onSnapshot(function(snapshot){
            setComentarios(snapshot.docs.map(function(document){
              return {id:document.id,info:document.data()}
            }))
          })
          /* db.collection('posts').doc(props.id).collection('likes').orderBy('desc').onSnapshot(function(snapshot){
            setLikes(snapshot.docs.map(function(document){
              return {id:document.id}
            }))
          }) */
    },[])

    function comentar(id, e){
        e.preventDefault();

        let comentarioAtual = document.querySelector('#comentario-'+id).value;
        
        db.collection('posts').doc(id).collection('comentarios').add({
            nome: props.user,
            comentario: comentarioAtual,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
        })

        document.querySelector('#comentario-'+id).value = "";
    }

    function like(id, e) {
        e.preventDefault();
        let statusLike = false
        let likeicon = document.querySelector('#like-'+id);
        let likeIcon = document.querySelector('#heartLiked');


        let LikesAtual = document.querySelector('#like-'+id);
        let LikesTotal = isNaN(LikesAtual)
        let totalLikes = Number(LikesTotal);

        likeicon.addEventListener('click', () => {
            if(statusLike == false) {

                likeicon.style.display = "none"
                likeIcon.style.display = "block";
                return statusLike=true
            } 
        })

        likeIcon.addEventListener('click', () => {
            if(statusLike == true) {

                likeIcon.style.display = "none";
                likeicon.style.display = "block";
                return statusLike=false
            }
        })

        db.collection('posts').doc(id).collection('likes').add({
            nome: props.user,
            likes: totalLikes + 1,
        })

        document.querySelector('#like-'+id);
    } 

    
     

    return (
        
        <div className="postSingle">


            <p className="usrps1">{/* <img src="#"/> */}<i class="fas fa-user-circle"></i> <b>{props.info.userName}</b></p>
            <img src={props.info.image}/>

            <div className="iconsPerson">
                <p className="likeIcon" id={"like-"+props.id} onClick={(e) =>like(props.id,e)} ><i class="far fa-heart"></i></p> 
                
                <p className="likeIcon iconView" id="heartLiked" ><i class="fas fa-heart"></i></p> 
                
            </div>
            
            <div className="likesIds">
                {/* <h4>COMENTÁRIOS RECENTES:</h4> */} 
                {
                    likes.map(function(val){
                        return(
                            <div className="like-single">
                            <p><b> {val.info.nome}</b>curtiu</p>
                            </div>
                        )
                    })
                }
            </div>

                            
            
            <p className="usrps">{/* <img src="#"/> */}<i class="fas fa-user-circle"></i> <b>{props.info.userName}</b>: {props.info.titulo}</p>

            <div className="coments">
                {/* <h4>COMENTÁRIOS RECENTES:</h4> */} 
                {
                    comentarios.map(function(val){
                        return(
                            <div className="coment-single">
                            <p>{/* <img src="#"/> */}<i class="fas fa-user-circle"></i><b> {val.info.nome}</b>: {val.info.comentario}</p>
                            </div>
                        )
                    })
                }
            </div>
                {
                    (props.user)?
                    <form onSubmit={(e)=>comentar(props.id,e)}>
                        <textarea id={"comentario-"+props.id} placeholder="Escreva um comentário..."></textarea>
                        <input type="submit" value="Comentar"/>
                    </form>
                    :
                    <div></div>
                }
        </div> 
        

    )
}

export default Post;